import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'

@Component({
  selector: 'dmmp-dynamics-module',
  templateUrl: './dynamics-module.component.html'
})
export class DynamicsModuleComponent implements OnInit {

  @Input() dataComponent
  @Input() result
  @Input() identifier
  @Input() inSlide
  @Output() notSupportedEmitter = new EventEmitter()
  @Output() clearResult = new EventEmitter()
  @Output() close = new EventEmitter()
  @Output() search = new EventEmitter()
  @Output() page = new EventEmitter()
  @Output() anchorCustom = new EventEmitter()

  constructor() { }

  ngOnInit(): void {
  }

}
